// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"checkBox_wrapper_2myuK","span":"checkBox_span_1IF5W","input":"checkBox_input_I7pnL"};